import React from "react";
import styles from './CheckBoxWithHeader.styl';

function CheckBoxWithHeader(props) {

	const {labelX, labelY, widthLbl, title, x, y, type, value, ...addProps} = props
	return <div>
		<label className={styles.modeChk}
					 style={{top: labelY + 'px', left: labelX + 'px', width: widthLbl + 'px', zIndex: '14'}}
					 htmlFor={type}>{title}</label>
		<input
			style={{top: y + 'px', left: x + 'px', position: 'absolute', zIndex: '10', height: '16px', width: '16px'}}
			type="checkbox"
			checked={value}
			disabled={false}
			id={type}
			{...addProps}
		/>
	</ div>

}

export default CheckBoxWithHeader;



// WEBPACK FOOTER //
// ./src/react/ui/features/CheckBoxWithHeader/CheckBoxWithHeader.jsx